<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="" />
						<col style="width:200px;" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Return Order No</th>
							<td colspan="2">
								<input type="text" v-model.trim="invoice.so_dn" class="tbl_int ssm2_int" readonly disabled />
								<span style="font-weight:bold;color:blue">Return</span>
							</td>

							<th>Entry User</th>
							<td>
								<input type="text" v-model.trim="invoice.crt_user" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="invoice.upd_dt"> &nbsp;Last updated : {{ invoice.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ invoice.upd_user }} </template>
								<span style="float:right;"><a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="addNew">Reset (Add New)</a></span>
							</td>
							<!-- <th>Invoice No</th> -->
						</tr>
						<tr>
							<th>Return Date / Status</th>
							<td colspan="2">
								<CustomDatePicker v-model="invoice.so_date" :disabled="mode == 'detail' && !user.admin && !user.so_date_modifiable" style="display:inline-block;margin-right:10px;" />
								<CodeSelect className="tbl_select" :codes="saleStatusCodes" :width="60" :showDesc="true" :codeBold="true" :descBold="true" :disabled="true" v-model="invoice.status_code" style="display:inline-block;" />
								<template v-if="user.company_id == 'newjigu' && partner.notice"><input type="text" class="tbl_int lm_int" style="margin-left:10px;color:red;display:inline-block;" :value="partner.notice" readonly /> </template>
							</td>

							<th>Call Tag No</th>
							<td>
								<input type="text" v-model.trim="invoice.call_tag_dn" class="tbl_int ssm2_int" readonly disabled />
								, Call Tag / Actual Box Count :
								<currency-input type="text" v-model="invoice.call_tag_box_count" :precision="0" class="tbl_int sssm_int al_right" readonly />
								/
								<currency-input type="text" v-model="invoice.box_count" :precision="0" class="tbl_int sssm_int al_right" />
							</td>
						</tr>
						<tr>
							<th>Ship To</th>
							<td colspan="2">
								<div style="float:left;"><PartnerSelect ref="shipto" v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" :activeOnly="true" :customerOnly="true" ph="Ship To" @set-partner="setShipTo" /></div>
								<!-- <button class="gray_bt" style="margin-left:5px;" @click="openModal('Memo')"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button> -->
							</td>
							<th>Bill To</th>
							<td>
								<PartnerSelect v-model="invoice.bill_to_code" :initialName="invoice.bill_to_name" ph="Bill To" :activeOnly="true" :customerOnly="true" @set-partner="setBillTo" />
							</td>
						</tr>
						<tr>
							<th>Ship To Address</th>
							<td colspan="2">
								<input type="text" class="tbl_int near_full_int" :value="shipToAddressString()" readonly />
								<a href="javascript:;" type="button" class="gray_bt3" @click="modifyAddress()">...</a>
							</td>
							<th>Return Type</th>
							<td>
								<select v-model="invoice.return_type_code" class="tbl_select half_int">
									<option v-for="c in returnTypes" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>Sales Person</th>
							<td>
								<div style="float:left;"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="invoice.sales_group_code" /></div>
								<button v-if="salesGroupModifiable && mode == 'detail' && invoice.status_code == 'I'" class="gray_bt" style="margin-left:5px;" @click="updateSalesGroup()">Update</button>
							</td>
							<td></td>
							<th>To Accounting</th>
							<td><input type="text" v-model.trim="invoice.remark" class="tbl_int red_bold" placeholder="To Approval or Invoice Staff" /></td>
							<!-- <td colspan="2" rowspan="3" style="padding-left:50px;">
								<table class="view_tbl3" border="1">
									<tbody>
										<tr>
											<th class="al_right remark-table">To Accounting</th>
											<td class="remark-table"><input type="text" v-model.trim="invoice.remark" class="remark_int red_bold" placeholder="To Approval or Invoice Staff" /></td>
										</tr>
									</tbody>
								</table>
							</td> -->
						</tr>
						<tr>
							<th>Quantity<span v-if="invoice.status_code == 'I'">(Shipped)</span></th>
							<td>
								<currency-input type="text" v-model="invoice.total_quantity" :precision="0" class="tbl_int ssm_int al_right mgr_15" readonly />
								<template v-if="mode === 'detail'">
									<span style="font-weight:bold;">Returned Box : </span>
									<span>{{ invoice.returned_box_count }} Box(es)</span>
									<a href="javascript:void(0);" class="gray_bt" @click="() => (show_returned_box_detail = true)">Box Detail</a>
								</template>
							</td>
							<td></td>
							<th>To Warehouse Staff</th>
							<td><input type="text" v-model.trim="invoice.remark2" class="tbl_int red_bold" placeholder="To Warehouse Staff" /></td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<!-- <div v-if="!invoice.pt_print_dt" class="left_option" style="display:inline;"> -->
			<div v-if="invoice.status_code != 'I' && invoice.status_code != 'VI'" class="left_option" style="display:inline;">
				<!-- <em style="padding-left:20px;padding-right:10px;"><b>Search Item(s) : </b></em>
				<em class="lt_text">Item Class</em> -->
				<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" :resetAfterPopup="true" @set-item-class="setItemClass" :disabled="!invoice.ship_to_code" /> </span>

				<input type="text" :disabled="!itemEditable" ref="barcode_to_find" class="tbl_int" v-model.trim="barcode_to_find" placeholder="Barcode Scan" autocomplete="off" style="width:170px;" @keypress.enter="findAndPut()" />
				<span class="int_type half_int">
					<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" /> -->
					<!-- <vue-bootstrap-typeahead ref="ac" v-model.trim="keyword" :maxMatches="20" :data="acClasses" :serializer="s => s.name" placeholder="Class Name, Keyword or Barcode" @hit="acSelected = $event" /> -->
					<AC ref="ac" v-show="itemEditable" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'">
					</AC>
				</span>

				<a v-if="itemEditable" href="javascript:;" class="search_bt mgr_15" @click="search()">Search and Add Item(s)</a>
			</div>

			<div ref="div_wrapper" :key="div_wrapper_key">
				<table class="list_tbl mgb_0 add_top_line" ref="invoice_items">
					<thead>
						<tr>
							<th colspan="9" class="al_center"><font class="tbl_chk">Continue Item List</font></th>
						</tr>
						<tr>
							<th width="3%"><input type="checkbox" v-model="selected_continue_list" @change="selectAllContinueList()" /></th>
							<th width="8%">{{ headers.class }}</th>
							<th>Name</th>
							<th width="10%">Color</th>
							<!-- <th width="5%">Price</th> -->
							<th width="5%">Return</th>
							<th width="5%">Damage<br />Sticky</th>
							<th width="5%">Damage Repacking</th>
							<th width="5%">Damage Closed</th>
							<th width="5%">Regular Return</th>
						</tr>
					</thead>
					<tbody v-if="continue_list && continue_list.length">
						<tr v-for="(item, index) in continue_list" v-bind:key="item.invoice_item_no" v-bind:class="{ on: item == selectedItem }" @click="selectRow(item)">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">
								<template v-if="index == 0 || (index > 0 && item.class_code != continue_list[index - 1].class_code)">
									<input type="checkbox" v-model="item.class_selected" @change="classCheckChanged(item)" />
									<b v-if="item.class_active_yn == 'N'"><font color="red">!!</font></b>
									<font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.class_code }}</font>
								</template>
							</td>
							<td class="al_left">
								<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
								<a href="javascript:;" @click="selectItem(item)">
									<font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.name }}</font>
								</a>
								<span v-if="item.pastedItem">
									(<b><font color="blue">Pasted Item</font></b
									>)
								</span>
							</td>

							<td class="al_left">{{ item.color_code }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.quantity_abs"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="quantity"
									@keydown.down.prevent="goTo(item, 1)"
									@keydown.up.prevent="goTo(item, -1)"
									@keydown.enter.prevent="goTo(item, 1)"
									@input="checkOrderQuantity(item)"
								/>
							</td>

							<td class="al_right"><currency-input type="text" v-model.trim="item.return_s_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_r_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_x_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_rr_quantity" :precision="0" class="r_int long_type al_right" readonly /></td>
						</tr>
					</tbody>
					<tbody v-else></tbody>
				</table>

				<table class="list_tbl mgb_0 add_top_line" ref="invoice_items_2">
					<thead>
						<tr>
							<th colspan="9" class="al_center"><font class="tbl_chk">Discontinue Item List</font></th>
						</tr>
						<tr>
							<th width="3%"><input type="checkbox" v-model="selected_discontinue_list" @change="selectAllDiscontinueList()" /></th>
							<th width="8%">{{ headers.class }}</th>
							<th>Name</th>
							<th width="10%">Color</th>
							<!-- <th width="5%">Price</th> -->
							<th width="5%">Return</th>
							<th width="5%">Damage<br />Sticky</th>
							<th width="5%">Damage Repacking</th>
							<th width="5%">Damage Closed</th>
							<th width="5%">Regular Return</th>
						</tr>
					</thead>
					<tbody v-if="discontinue_list && discontinue_list.length">
						<tr v-for="(item, index) in discontinue_list" v-bind:key="item.invoice_item_no" v-bind:class="{ on: item == selectedItem }" @click="selectRow(item)">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">
								<template v-if="index == 0 || (index > 0 && item.class_code != discontinue_list[index - 1].class_code)">
									<input type="checkbox" v-model="item.class_selected" @change="classCheckChanged(item)" />
									<b v-if="item.class_active_yn == 'N'"><font color="red">!!</font></b>
									<font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.class_code }}</font>
								</template>
							</td>
							<td class="al_left">
								<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
								<a href="javascript:;" @click="selectItem(item)">
									<font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.name }}</font>
								</a>
								<span v-if="item.pastedItem">
									(<b><font color="blue">Pasted Item</font></b
									>)
								</span>
							</td>

							<td class="al_left">{{ item.color_code }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.quantity_abs"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="quantity"
									@keydown.down.prevent="goTo(item, 1)"
									@keydown.up.prevent="goTo(item, -1)"
									@keydown.enter.prevent="goTo(item, 1)"
									@input="checkOrderQuantity(item)"
								/>
							</td>

							<td class="al_right"><currency-input type="text" v-model.trim="item.return_s_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_r_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_x_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
							<td class="al_right"><currency-input type="text" v-model.trim="item.return_rr_quantity" :precision="0" class="r_int long_type al_right" readonly /></td>
						</tr>
					</tbody>
					<tbody v-else></tbody>
				</table>
			</div>

			<div class="tbl_bottom_bt">
				<input type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<!-- <input type="button" value="All Return" class="int_line_bt" /> -->
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<!-- <input v-if="true" type="button" value="Copy" class="int_line_bt" style="margin-left:5px" @click="copyItems()" />
				<input type="button" value="Paste" class="int_line_bt" style="margin-left:5px" @click="pasteItems()" /> -->
			</div>

			<div class="view_bottom_bt">
				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt" @click="tempSave()">Temp Save</a>
				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt mgr_10" @click="tempDelete()">Temp Delete</a>

				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>

				<!-- <a href="javascript:;" type="button" class="gray_bt mgr_15" @click="viewHistory()">History</a> -->
				<a v-if="mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt" @click="labelPrint()">Label Print</a>
				<a v-if="mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="returnSalesOrder()">Print</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Back</a>

				<!-- <a href="javascript:;" type="button" :disabled="mode == 'add'" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="delPartner()" class="delete_button">Delete</a> -->
			</div>
		</div>

		<Modal @close="closeModal(true)" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<!-- <ItemPopup :initialItems="searchItems" :initialItemClass="itemClass" :initialKeyword="keyword" :ship_to_code="invoice.ship_to_code" :v-on:close="closeModal()" @set-items="addItems" /> -->
				<ItemPopup
					:initialItems="searchItems"
					:initialItemClass="itemClass"
					:initialClassName="className"
					:initialKeyword="keyword"
					invoice_type="R"
					:fromWarehouse="true"
					:ship_to_code="invoice.ship_to_code"
					:focusOnAC="focusItemPopupAC"
					@forcedFocusOnAC="focusItemPopupAC = false"
					@close="closeModal(true)"
					@set-items="addItems"
				/>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ShipToAddress'" :draggable="false">
			<template slot="title">Ship To Address</template>
			<template slot="body">
				<div style="width:600px; height:260px;">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Company Name</th>
								<td><input type="text" v-model.trim="ship_to_address.ship_to_name" class="tbl_int full_int" @focus="$event.target.select()" /></td>
							</tr>
							<tr>
								<th>Address</th>
								<td><input type="text" v-model.trim="ship_to_address.address_detail" class="tbl_int full_int" @focus="$event.target.select()" /></td>
							</tr>
							<tr>
								<th>City / State</th>
								<td>
									<input type="text" v-model.trim="ship_to_address.address_city" class="tbl_int half_int" @focus="$event.target.select()" /> /
									<input type="text" v-model.trim="ship_to_address.address_state" class="tbl_int sssm_int" @focus="$event.target.select()" />
								</td>
							</tr>
							<tr>
								<th>Zip / Country</th>
								<td>
									<input type="text" v-model.trim="ship_to_address.address_zipcode" class="tbl_int sssm_int" @focus="$event.target.select()" /> /
									<input type="text" v-model.trim="ship_to_address.address_country" class="tbl_int sm_int" @focus="$event.target.select()" />
								</td>
							</tr>
							<tr>
								<th>Telephone</th>
								<td><input type="text" v-model.trim="ship_to_address.telephone" class="tbl_int full_int" @focus="$event.target.select()" /></td>
							</tr>
							<tr>
								<th><font color="red">Previous Address</font></th>
								<td>
									<select class="tbl_select full_int" v-model="selected_prev_address_index" @change="selectPrevAddress()">
										<option value="-1">Select !!!</option>
										<option v-for="(addr, index) in filtered_prev_ship_to_address_list" v-bind:value="index" v-bind:key="index"
											>{{ addr.ship_to_name }}, {{ addr.address_detail }}, {{ addr.address_city }}, {{ addr.address_state }} {{ addr.address_zipcode }}</option
										>
									</select>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="applyAddr()" class="search_bt mgr_15">Apply & Close</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<ReturnedBoxPopup v-if="show_returned_box_detail" @close="closeReturnBoxModal()" :invoice_no="invoice.invoice_no" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectPartner } from '@/api/partner/index.js';
import {
	apiDeleteTempInvoice,
	apiInsertInvoice,
	apiInsertTempInvoice,
	apiSelectInvoice,
	apiSelectShipToAddressHistory,
	apiSelectTempInvoice,
	apiSoIndex,
	apiUpdateInvoice,
	apiUpdateSalesGroup,
	apiUpdateTempInvoice,
	apiInvoicePrintData,
	apiUpdateSalesOrderPrint,
} from '@/api/sales/invoice.js';
import { apiSelectInvoiceItemList, apiSelectReturnBoxList, apiSelectReturnBoxCount } from '@/api/sales/boxing.js';
import { apiSelectCallTag } from '@/api/sales/calltag.js';
import { apiGetReportTemplate, getMrtFile, companyMrtUrl, reportMrtUrl, Report, PrintType } from '@/api/util';
import { apiSelectItem, apiSelectItemList } from '@/api/item/master.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemPopup from '@/components/common/ItemPopup';
import Modal from '@/components/common/Modal';
import _ from 'lodash';
import 'floatthead';
import AC from '@/components/common/AC';
import { isMobile } from 'mobile-device-detect';
import ReturnedBoxPopup from '@/components/common/ReturnedBoxPopup';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/sales/so_main',

			paging_yn: 'Y',
			page_size: 4,
			page_no: 1,
			list_count: 0,

			mode: 'add',
			sale_only: false,
			return_only: false,
			invoice: {
				invoice_type: 'R',
				so_dn: null,

				restock_fee: 0,
				other_charge: 0,

				auto_approved: false,
				pre_approval_reason: null,

				ship_to_address: {},
			},
			prev_ship_to_address_list: [],
			prev_ship_to_address_list_for_update: [],
			selected_prev_address_index: -1,
			partner: {},
			histories: [],

			ship_to_address: {},
			//history_items: [],

			popup_items: [],

			//acClasses: [],
			//acSelected: null,

			items: [],
			item_nos_to_delete: [],
			prevInvoices: [],
			prevInvoicesCount: 0,
			prevInvoicesBalanceSum: 0,
			postChecks: [],

			prevInvoice: {},

			callTag: {},

			shipToAddresses: [],

			additionalSO: false,
			//docs: [],

			// itemSearchOptions: {},

			businessTypes: [],
			grades: [],
			races: [],
			deliveryTypes: [],
			returnTypes: [],
			shipCharges: [],
			salesGroups: [],
			filteredSalesGroups: [],
			paymentTerms: [],
			remarks: [],
			specialSales: [],
			recipetTypes: [],
			arTypes: [],
			docTypes: [],
			saleStatusCodes: [],
			doc_type_code: null,
			doc_type_name: null,

			remark: null,
			allPreviousItemsSelected: false,
			allShipToAddressSelected: false,
			selected_continue_list: false,
			selected_discontinue_list: false,

			selectedItem: null,

			itemClass: null,
			className: null,
			barcode_to_find: null,
			keyword: '',
			searchItems: [],

			toReceiveInvoices: [],
			pay_amount_sum: null,

			current_credit: 0,
			// depts: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],
			modalName: '',
			prevModalName: '',
			showModal: false,

			tval: 1.45,
			locationNameObjList: '',
			labelShowModal: false,
			invoicePrintData: '',
			locationList: '',

			over_90: 0,
			grand_over: 0,

			total_request_amount: 0,

			selectedItemId: null,

			temp_save_flag: false,
			packingPrintHistoryModal: false,
			focusItemPopupAC: false,

			restock_fee_percent: null,
			div_wrapper_key: 0,

			show_returned_box_detail: false,
		};
	},
	computed: {
		itemEditable() {
			if (this.user.admin) return true;
			else if ((this.user.company_id == 'hairplus' || this.user.company_id == 'beautyplus') && this.user.dept_code == '3000') return false;

			return true;
		},
		salesGroupModifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		modifiable() {
			if (this.invoice.status_code && this.invoice.status_code != 'O') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		modeIsDetail() {
			return this.mode === 'detail';
		},

		filtered_prev_ship_to_address_list() {
			return this.prev_ship_to_address_list.filter(a => a.active);
		},
		continue_list() {
			return this.items.filter(item => item.class_closed_yn !== 'Y');
		},
		discontinue_list() {
			return this.items.filter(item => item.class_closed_yn === 'Y');
		},
	},
	watch: {
		invoice: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			//handler: function(newVal, oldVal) {
			handler: function() {
				this.calTotal();
				// let change_items = false;
				// const new_val = newVal || [];
				// const old_val = oldVal || [];
				// for (const n of new_val) {
				// 	if (!old_val.some(o => o === n)) {
				// 		change_items = true;
				// 		break;
				// 	}
				// }
				// if (!change_items) {
				// 	for (const o of old_val) {
				// 		if (!new_val.some(n => n === o)) {
				// 			change_items = true;
				// 			break;
				// 		}
				// 	}
				// }

				// if (change_items) this.div_wrapper_key++;
			},
		},
		// div_wrapper_key: {
		// 	handler() {
		// 		this.$nextTick(() => {
		// 			if (this.$refs.invoice_items) $(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });
		// 			if (this.$refs.invoice_items_2) $(this.$refs.invoice_items_2).floatThead({ zIndex: 1, autoReflow: true });
		// 		});
		// 	},
		// },
	},
	components: {
		ReturnedBoxPopup,
		PartnerSelect,
		CodeSelect,
		CustomDatePicker,
		ItemClassSelect,
		ItemPopup,
		Modal,
		AC,
	},
	methods: {
		async closeReturnBoxModal() {
			const param = { invoice_no: this.invoice.invoice_no };
			const { data } = await apiSelectReturnBoxCount(param);

			this.invoice.returned_box_count = data;
			this.show_returned_box_detail = false;
		},
		async returnSalesOrder() {
			//console.log('aaa');
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			// S/O Print 정보 Update
			if (!data.invoice.so_print_dt) this.updateSalesOrderPrint(data.invoice.invoice_no);

			const reportTemplate = await apiGetReportTemplate('ReturnSales', companyMrtUrl('ReturnSales'));
			const report = new Report(reportTemplate, data, 'ReturnSales');
			this.$store.commit('setReport', report);
		},
		labelPrint() {
			if (this.invoice.returned_box_count) this.labelPrintAfterBoxing();
			else this.labelPrintBeforeBoxing();
		},
		async labelPrintBeforeBoxing() {
			const now_dt = this.$moment(new Date());
			const { data } = await apiSelectInvoiceItemList(this.invoice.invoice_no, true);
			if (!Array.isArray(data)) {
				this.$toast.error('No Items to be Shown.');
				return;
			}

			const root = { invoice_no: this.invoice.invoice_no, so_dn: this.invoice.so_dn, scan_date: now_dt.format('MM-DD-YYYY'), scan_time: now_dt.format('HH:mm:ss'), items: data };
			const reportTemplate = await apiGetReportTemplate('ReturnLabel', reportMrtUrl('ReturnLabel'));
			const report = new Report(reportTemplate, root, 'ReturnLabel');
			this.$store.commit('setReport', report);
		},
		async labelPrintAfterBoxing() {
			const param = { invoice_no: this.invoice.invoice_no, for_boxing: true };
			const now_dt = this.$moment(new Date());
			const { data } = await apiSelectReturnBoxList(param);
			if (!Array.isArray(data) || !data.length) {
				this.$toast.error('No Items to be Shown.');
				return;
			}

			const roots = [];
			data.forEach(rb => {
				roots.push({
					invoice_no: this.invoice.invoice_no,
					scan_date: now_dt.format('MM-DD-YYYY'),
					scan_time: now_dt.format('HH:mm:ss'),
					items: rb.box_item_list || [],
					display_order_no: rb.order_no,
					discontinued: rb.discontinued,
					ship_to_code: rb.ship_to_code,
				});
			});

			const reportTemplate = await getMrtFile(reportMrtUrl('ReturnLabel'));
			const report = new Report(reportTemplate, roots, 'ReturnLabel', PrintType.List);
			this.$store.commit('setReport', report);
		},
		async updateSalesOrderPrint(invoice_no) {
			const { status } = await apiUpdateSalesOrderPrint(invoice_no);
			if (status !== 200) {
				this.$toast.error('Network Error');
				return;
			}
		},
		shipToAddressString() {
			var add = this.invoice.ship_to_address;

			if (add && Object.keys(add).length > 0) return add.ship_to_name + ', ' + add.address_detail + ', ' + add.address_city + ', ' + add.address_state + ' ' + add.address_zipcode;
			else return '';
		},
		applyAddr() {
			if (!this.ship_to_address.address_country) {
				this.$toast.error('Empty Country');
				return;
			}

			this.invoice.ship_to_address = _.cloneDeep(this.ship_to_address);
			this.closeModal();
			//this.$forceUpdate();
		},
		selectPrevAddress() {
			//console.log(this.selected_prev_address_index);
			if (this.selected_prev_address_index >= 0) this.ship_to_address = _.cloneDeep(this.filtered_prev_ship_to_address_list[this.selected_prev_address_index]);
		},
		async findAndPut() {
			if (!this.barcode_to_find) return;

			//console.log(this.invoice.call_tag_no);

			const { data } = await apiSelectItem({
				barcode: this.barcode_to_find,
				call_tag_no: this.invoice.call_tag_no,
				for_return: true,
			});
			//console.log(data);
			if (data.item) {
				var items = [];
				data.item.unit_price = data.item.price;
				data.item.quantity_abs = 1;
				items.push(data.item);
				this.mergeItems(items);
				//console.log(items);

				/* var found_item = this.items.filter(i => i.item_id == data.item.item_id)[0];
				if (found_item) {
					found_item.quantity_abs++;
				} else {
					data.item.unit_price = data.item.price;
					data.item.quantity_abs = 1;
					this.items.push(data.item);
				} */
				//this.item = data.item;
				//return true;;
			} else {
				this.$toast.error('Item Not Found');
			}
			this.$refs.barcode_to_find.select();
		},
		modifyAddress() {
			if (this.invoice.ship_to_address) this.ship_to_address = _.cloneDeep(this.invoice.ship_to_address);
			else this.ship_to_address = {};

			this.modalName = 'ShipToAddress';
			this.showModal = true;
		},
		applyAllClass(item) {
			this.items
				.filter(i => i.class_code == item.class_code && i.unit_price > 0)
				.forEach(i => {
					i.r_price = item.r_price + (i.min_price - item.min_price);
				});
		},
		classCheckChanged(item) {
			this.items
				.filter(i => i.class_code == item.class_code)
				.forEach(i => {
					//i.class_selected = item.class_selected;
					i.selected = item.class_selected;
				});
		},
		goTo(item, i) {
			this.$nextTick(() => {
				let next_item = null;
				let index = this.continue_list.findIndex(it => it === item);
				if (index > -1) {
					if (index + i > -1 && this.continue_list.length > index + i) {
						next_item = this.continue_list[index + i];
						index += i;
					}
				} else {
					index = this.discontinue_list.findIndex(it => it === item);
					if (index > -1) {
						if (index + i > -1 && this.discontinue_list.length > index + i) {
							next_item = this.discontinue_list[index + i];
							index = this.continue_list.length + index + i;
						}
					}
				}

				if (index > -1 && next_item) {
					const el = this.$refs.quantity[index].$el;
					const top = el.getBoundingClientRect().top;
					const margin = 100;
					el.select();

					if (top + margin > window.innerHeight) window.scrollTo(window.scrollX, window.scrollY + (top + margin - window.innerHeight));
					else if (top - margin < 0) window.scrollTo(window.scrollX, window.scrollY + (top - margin));

					this.selectedItem = next_item;
				}
			});
		},
		mergeItems(items) {
			var vm = this;
			var dupl_items = [];
			items.forEach(function(item) {
				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) {
					foundItems[0].quantity_abs += item.quantity_abs;
					dupl_items.push(item.item_code ? item.item_code : item.name + '(' + item.color_code + ')');
				} else {
					vm.items.push(_.cloneDeep(item));
				}
			});

			// Return일 경우 무시
			// if (dupl_items.length > 0) {
			// 	window.alert(dupl_items.join(', ') + ' Already Exist(s) in S/O List.\nPlease Check the Quantity of These Products');
			// 	this.focusItemPopupAC = true;
			// }

			if (this.mode == 'add') this.temp_save_flag = true;

			this.$forceUpdate();
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&for_sale_yn=Y&keyword=' + input;
			url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.className = c.selectedObject.name;
			this.search();
			//this.searchKeyword(c.selectedObject.code);

			//console.log(str);
		},
		searchKeyword(keyword) {
			//console.log(keyword);
			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();
		},
		selectItem(item) {
			//this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
			let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
			window.open(routeData.href, 'herp_item');
		},
		setItemClass(itemClass) {
			//console.log('hmmm', itemClass);
			this.itemClass = itemClass.code;
			this.className = itemClass.name;
			//console.log(this.itemClass);
			//console.log('set item class');
			this.search();
		},
		async search() {
			if (!this.invoice.ship_to_code) {
				this.$toast.error('Select Customer first.');
				return;
			}
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
			this.className = null;
		},
		deleteItems() {
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].invoice_item_no) this.item_nos_to_delete.push(this.items[i].invoice_item_no);
					this.items.splice(i, 1);
				}
			}
			if (this.mode == 'add') this.temp_save_flag = true;
		},
		cutItems() {
			this.copyItems();
			this.deleteItems();
		},
		copyItems() {
			//console.log('copy');
			if (this.items.filter(i => i.selected).length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (this.items.filter(i => i.selected).length > 500) {
				this.$toast.error('Too many items');
				return;
			}

			var c_items = _.cloneDeep(this.items.filter(i => i.selected));
			c_items.forEach(function(i) {
				i.invoice_item_no = null;
			});

			if (c_items.length > 0) {
				this.$session.set('items', c_items);
				this.$toast.success('Item copied or cut');
			}
		},
		async pasteItems() {
			if (!this.invoice.ship_to_code) {
				this.$toast.error('Select Customer first.');
				return;
			}
			//console.log(this.$session.get('items'));
			var item_ids = [];
			this.$session.get('items').forEach(i => {
				item_ids.push(i.item_id);
			});

			var param = {
				item_ids: item_ids,
				for_sale: true,
				ship_to_code: this.invoice.ship_to_code,

				include_available: true,
				include_on_board: true,
			};

			const { data } = await apiSelectItemList(param);
			var pItemList = data.itemList;
			//console.log(pItemList);
			var vm = this;
			pItemList.forEach(item => {
				var foundItems = vm.$session.get('items').filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) item.quantity_abs = foundItems[0].quantity_abs;
				//item.quantity_abs = item.quantity;
				item.unit_price = item.net_price;
				item.last_price = item.last_net_price;
				item.pastedItem = true;
				//item.selected = true;
			});
			//console.log(pItemList);
			// pItemList.forEach(function(item) {
			// 	var foundItems = vm.$session.get('items').filter(i => i.item_id == item.item_id);
			// 	if (foundItems.length > 0) item.quantity_abs = foundItems[0].quantity_abs;
			// 	//item.quantity_abs = item.quantity;
			// 	item.unit_price = item.net_price;
			// 	item.last_price = item.last_net_price;
			// });
			//console.log(data);

			//var c_items = this.$session.get('items');
			//this.items = this.items.concat(c_items);

			if (pItemList.length > 0) this.$toast.warning('Please check the price and quantity of the pasted item(s)');
			this.mergeItems(pItemList);

			//console.log(copiedItems);
		},
		selectAllContinueList() {
			this.continue_list.forEach(i => {
				i.selected = this.selected_continue_list;
			});
		},
		selectAllDiscontinueList() {
			this.discontinue_list.forEach(i => {
				i.selected = this.selected_discontinue_list;
			});
		},
		calTotal() {
			//console.log('calTotal Called');
			//console.log(this.items);
			var total_amount = 0;
			var total_quantity = 0;
			var total_shipped_amount = 0;
			var total_shipped_quantity = 0;
			var total_valid_amount = 0;
			var total_valid_quantity = 0;
			this.total_request_amount = 0;

			this.items.forEach(function(item) {
				item.quantity = item.quantity_abs * -1;
				item.shipped_quantity = item.shipped_quantity_abs * -1;

				item.return_rr_quantity = item.quantity_abs - item.return_s_quantity - item.return_x_quantity - item.return_r_quantity;

				item.amount = item.quantity * item.unit_price;
				item.shipped_amount = item.shipped_quantity * item.unit_price;

				total_quantity += item.quantity;
				total_amount += item.amount;
				total_shipped_quantity += item.shipped_quantity;
				total_shipped_amount += item.shipped_amount;

				// if (!(item.quantity_abs > 0)) item.selected = true;
				// else item.selected = false;
			});

			this.invoice.total_quantity = total_quantity;
			this.invoice.total_amount = total_amount;
			this.invoice.total_shipped_quantity = total_shipped_quantity;
			this.invoice.total_shipped_amount = total_shipped_amount;
			this.invoice.total_valid_quantity = total_valid_quantity;
			this.invoice.total_valid_amount = total_valid_amount;

			if (this.invoice.status_code == 'I') this.invoice.invoice_amount = this.invoice.total_shipped_amount + this.invoice.restock_fee + this.invoice.other_charge;
			else this.invoice.invoice_amount = this.invoice.total_amount + this.invoice.restock_fee + this.invoice.other_charge;

			if (this.temp_save_flag) {
				this.temp_save_flag = false;
				this.tempSave();
			}
		},
		async tempSave() {
			//console.log('temp save');

			this.invoice.items = this.items;

			var response;
			if (this.invoice.temp_invoice_no > 0) {
				response = await apiUpdateTempInvoice(this.invoice);
			} else {
				response = await apiInsertTempInvoice(this.invoice);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Temporarily Saved');
				if (!(this.invoice.temp_invoice_no > 0)) {
					this.invoice.temp_invoice_no = data.temp_invoice_no;
					this.$forceUpdate();
					//console.log('temp saved', this.invoice.temp_invoice_no);
					//this.$router.replace(this.$route.fullPath + '&temp_invoice_no=' + this.invoice.temp_invoice_no).catch(err => err);
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async tempDelete() {
			this.$alertify.confirm('Are you sure to delete?', () => {
				this.tempDeleteConfirm();
			});
		},
		async tempDeleteConfirm() {
			const { data } = await apiDeleteTempInvoice(this.invoice);

			if (data.result) {
				this.$toast.success('Deleted successfully');
				this.$router.push(this.backUri);
			} else {
				this.$toast.error('Failed');
			}
		},
		checkOrderQuantity(item) {
			if (!(item.quantity_abs > 0)) {
				item.selected = true;
			}
		},
		selectRow(item) {
			this.selectedItem = item;
		},

		async loadShipToAddressHistory(partner) {
			const { data } = await apiSelectShipToAddressHistory({
				ship_to_code: partner.code,
			});

			this.prev_ship_to_address_list = data.shipToAddressList;
		},
		async setShipTo(partner) {
			this.partner = partner;

			this.invoice.partner_blocked = partner.blocked;
			this.invoice.ship_to_name = partner.name;
			this.invoice.ship_charge_code = partner.ship_charge_code;
			this.invoice.payment_term_code = partner.payment_term_code;
			this.invoice.sales_group_code = partner.sales_group_code;
			this.invoice.delivery_type_code = partner.delivery_type_code;

			this.invoice.ship_to_grade = partner.grade_code;
			this.invoice.ship_to_credit_limit = partner.credit_limit;
			this.invoice.ship_to_total_credit_limit = partner.total_credit_limit;

			// this.invoice.bill_to_code = this.invoice.ship_to_code;
			// this.invoice.bill_to_name = this.invoice.ship_to_name;

			//console.log(partner.current_credit);
			this.current_credit = partner.current_credit;

			//this.invoice.ar_days = partner.ar_days;

			//this.invoice.ship_to_address = partner.address_detail + ', ' + partner.address_city + ', ' + partner.address_state + ' ' + partner.address_zipcode;
			this.invoice.ship_to_address = {
				ship_to_name: partner.name,
				address_detail: partner.address_detail,
				address_city: partner.address_city,
				address_state: partner.address_state,
				address_zipcode: partner.address_zipcode,
				address_country: partner.country,
				telephone: partner.telephone,
			};

			this.loadShipToAddressHistory(partner);

			if (this.invoice.sales_group_code) {
				this.filteredSalesGroups = this.salesGroups.filter(sg => sg.code == this.invoice.sales_group_code);
			} else {
				this.filteredSalesGroups = this.salesGroups;
			}

			if (this.partner.code == this.partner.last_bill_to_code || (this.partner.last_bill_to_code == null && this.partner.bill_to_code == null)) {
				this.invoice.bill_to_code = this.invoice.ship_to_code;
				this.invoice.bill_to_name = this.invoice.ship_to_name;
				this.invoice.ar_days = partner.ar_days;
			} else if (this.partner.last_bill_to_code || this.partner.bill_to_code) {
				var search_bill_to_code = this.partner.last_bill_to_code ? this.partner.last_bill_to_code : this.partner.bill_to_code;

				var { data } = await apiSelectPartner({
					code: search_bill_to_code,
				});

				if (data.partner) {
					this.invoice.bill_to_code = search_bill_to_code;
					this.invoice.bill_to_name = data.partner.name;
					this.invoice.ar_days = data.partner.ar_days;
				}
			}

			this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		setBillTo(partner) {
			//console.log(partner);
			this.invoice.bill_to_code = partner.code;
			this.invoice.bill_to_name = partner.name;
			this.invoice.payment_term_code = partner.payment_term_code;

			this.invoice.ar_days = partner.ar_days;

			this.$forceUpdate();
		},
		// copy_ship_to_bill() {
		// 	// this.$nextTick(function() {
		// 	// 	console.log(this.invoice);
		// 	// 	this.invoice.bill_to_code = this.invoice.ship_to_code;
		// 	// 	this.invoice.bill_to_name = this.invoice.ship_to_name;
		// 	// 	console.log(this.invoice);
		// 	// });
		// 	//console.log(this.invoice);
		// 	this.invoice.bill_to_code = this.invoice.ship_to_code;
		// 	this.invoice.bill_to_name = this.invoice.ship_to_name;
		// 	//console.log(this.invoice);
		// 	this.$forceUpdate();
		// },
		setRemark(code) {
			//console.log(test);
			if (code) this.invoice.remark = code.name;
		},
		updateRemark() {
			this.remark = null;
		},
		async selectInvoice() {
			const { data } = await apiSelectInvoice({
				invoice_no: this.invoice.invoice_no,
				include_history: true,
				include_partner: true,

				include_ship_to_address: true,
				include_returned_box_count: true,
			});
			//console.log(data.invoice);
			//console.log(data.invoice.auto_approved);
			this.invoice = data.invoice;
			this.invoice.org_status_code = this.invoice.status_code;
			//console.log(data.invoice.auto_approved, data.invoice.org_auto_approved, this.invoice.auto_approved);
			this.invoice.org_auto_approved = this.invoice.auto_approved;
			//console.log(data.invoice.auto_approved, data.invoice.org_auto_approved, this.invoice.auto_approved);
			this.invoice.org_designated = this.invoice.designated;
			this.invoice.ship_to_address = data.shipToAddress;
			//console.log(this.invoice.ship_to_address);
			this.partner = data.partner;
			//if (this.partner.memo) this.openModal('Memo');
			// refrence udpate를 위해서 먼저 비운다음, 다시 할당함
			this.items = [];
			await this.$nextTick();
			this.items = data.invoiceItemList;
			this.histories = data.invoiceHistoryList;
			//console.log(this.histories);
			if (data.calltag) {
				this.callTag = data.callTag;
				//console.log(this.callTag);
				if (this.callTag.tracking_nos) {
					this.callTag.tracking_nos = this.callTag.tracking_nos.split('|');
				} else {
					this.callTag.tracking_nos = [];
				}
			} else {
				this.callTag = {};
			}

			//console.log('*' + this.invoice.ship_to_code + '*');
			if (this.invoice.ship_to_code != null) {
				this.loadShipToAddressHistory(data.partner);
			}

			if (this.invoice.sales_group_code) {
				this.filteredSalesGroups = this.salesGroups.filter(sg => sg.code == this.invoice.sales_group_code);
			} else {
				return (this.filteredSalesGroups = this.salesGroups);
			}

			this.additionalSO = this.invoice.main_invoice_no ? true : false;
			//this.loadPreviouseInvoices(this.invoice.ship_to_code);

			//console.log(this.invoice);
			//console.log(this.items);
		},

		async checkSalesDate() {
			if (this.mode == 'add' && this.invoice.so_date != today()) {
				return confirm('Sales date is not today. Continue?');
			} else {
				return true;
			}
		},
		async checkValidity() {
			if (!this.invoice.so_date) {
				this.$toast.error('Empty Sales Date');
				return false;
			}

			if (!this.invoice.ship_to_code) {
				this.$toast.error('Empty Ship To Code');
				return false;
			}

			if (!this.invoice.bill_to_code) {
				this.$toast.error('Empty Bill To Code');
				return false;
			}

			if (this.mode == 'detail') {
				var invoiceToSubmit = await this.selectInvoiceForSave();

				if (!invoiceToSubmit) {
					this.$toast.error('Not found');
					return false;
				}

				//console.log(invoiceToSubmit.status_code, this.invoice.org_status_code);
				if (invoiceToSubmit.status_code != this.invoice.org_status_code) {
					this.$toast.error('SO status changed by someone. Please reload the page');
					return false;
				}
			}
			//}

			//console.log('test3');
			//return false;

			return true;
		},
		async save(stay) {
			if (await this.checkValidity()) {
				if (await this.checkSalesDate()) await this.submit(stay, false);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async selectInvoiceForSave() {
			const { data } = await apiSelectInvoice({
				so_dn: this.invoice.so_dn,
			});

			return data.invoice;
		},
		async submit(stay, status_changed) {
			this.invoice.items = this.items;
			this.invoice.item_nos_to_delete = this.item_nos_to_delete;

			var response;
			if (this.mode == 'add') {
				this.invoice.source = isMobile ? 'MOBILE WEB' : 'PC WEB';

				response = await apiInsertInvoice(this.invoice);
			} else {
				response = await apiUpdateInvoice(this.invoice, status_changed);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				//console.log(this.backUri);
				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.invoice.invoice_no = data.invoice_no;
						this.invoice.so_dn = data.so_dn;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Sales Order -> Detail');
					}
					await this.selectInvoice();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateSalesGroup() {
			const { data } = await apiUpdateSalesGroup(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		addNew() {
			this.mode = 'add';
			this.$store.commit('setSubTitle', 'Sales Order -> Add');
			this.sale_only = false;
			this.return_only = false;
			this.invoice = {
				invoice_type: this.invoice.invoice_type,
				so_dn: null,
				restock_fee: 0,
				other_charge: 0,

				ship_to_address: {},
			};
			this.prev_ship_to_address_list = [];
			this.partner = {};
			this.histories = [];
			this.popup_items = [];
			this.items = [];
			this.item_nos_to_delete = [];
			this.prevInvoices = [];
			this.prevInvoicesCount = 0;
			this.prevInvoicesBalanceSum = 0;
			this.postChecks = [];
			this.prevInvoice = {};
			this.callTag = {};
			this.shipToAddresses = [];
			this.additionalSO = false;
			this.allPreviousItemsSelected = false;
			this.selected_continue_list = false;
			this.selected_discontinue_list = false;
			this.itemClass = null;
			this.className = null;
			this.keyword = '';
			this.searchItems = [];

			this.toReceiveInvoices = [];
			this.pay_amount = null;
			this.current_credit = 0;

			this.modalName = '';
			this.prevModalName = '';
			this.showModal = false;

			this.tval = 1.45;
			this.locationNameObjList = '';
			this.labelShowModal = false;
			this.invoicePrintData = '';
			this.locationList = '';

			var uri = '/sales/so/add?backUri=' + this.backUri;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);

			this.invoice.so_date = today();
			this.page_no = 1;
			this.$refs.paging.setPage(this.page_no, this.page_size, this.prevInvoicesCount);

			this.$forceUpdate();
			this.$refs.shipto.$el.children[0].focus();
		},

		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(focusToAc) {
			if (this.modalName == 'ItemSelect') {
				this.keyword = '';
				this.itemClass = null;
				this.className = null;
			}

			this.showModal = false;

			if (focusToAc) this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		labelModal() {
			this.labelShowModal = false;
		},
		closeDoubleModal() {
			//this.modalName = 'History';
			this.modalName = this.prevModalName;
		},
		addItems(items) {
			//console.log(items);
			//var vm = this;
			//items.forEach(item => (item.unit_price = item.net_price));
			var to_add_items = [];
			items.forEach(function(item) {
				item.quantity_abs = item.quantity;
				item.unit_price = item.net_price;
				item.last_price = item.last_net_price;
				//vm.items.push(item);
				to_add_items.push(item);
			});

			this.mergeItems(to_add_items);

			this.reset();

			//console.log(items);
		},
		async index() {
			const { data } = await apiSoIndex();

			this.paymentTerms = data.paymentTermList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.deliveryTypes = data.deliveryTypeList;
			this.returnTypes = data.returnTypeList;
			this.remarks = data.remarkList;
			this.specialSales = data.specialSaleList;
			this.locationList = data.locationList;
		},
		async selectTempInvoice() {
			const { data } = await apiSelectTempInvoice({
				temp_invoice_no: this.invoice.temp_invoice_no,
			});
			//console.log(data);

			this.invoice = _.cloneDeep(data.tempInvoice);
			this.invoice.ship_to_address = {
				ship_to_name: data.tempInvoice.address_ship_to_name,
				address_detail: data.tempInvoice.address_detail,
				address_city: data.tempInvoice.address_city,
				address_state: data.tempInvoice.address_state,
				address_zipcode: data.tempInvoice.address_zipcode,
				address_country: data.tempInvoice.address_country,
				telephone: data.tempInvoice.telephone,
			};

			this.items = data.tempInvoiceItemList;
			this.partner = data.partner;

			if (this.partner) this.setShipTo(this.partner);
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			var response;

			if (this.mode == 'detail') {
				await this.selectInvoice();
				//console.log(this.user, this.modifiable);
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			} else if (this.mode == 'add' && this.invoice.temp_invoice_no > 0) {
				await this.selectTempInvoice();
			} else if (this.mode == 'add' && this.$route.query.ship_to_code) {
				this.sale_only = true;
				this.invoice.ship_to_code = this.$route.query.ship_to_code;
				response = await apiSelectPartner({
					code: this.invoice.ship_to_code,
				});

				if (response.data.partner) {
					this.setShipTo(response.data.partner);
				}
			} else if (this.mode == 'add' && this.$route.query.call_tag_no) {
				this.return_only = true;
				this.invoice.invoice_type = 'R';
				this.invoice.call_tag_no = this.$route.query.call_tag_no;

				response = await apiSelectCallTag({
					call_tag_no: this.$route.query.call_tag_no,
				});
				//console.log(response.data);
				if (response.data.call_tag.weights) {
					this.invoice.call_tag_box_count = response.data.call_tag.weights.split('|').length;
					this.invoice.box_count = response.data.call_tag.weights.split('|').length;
				} else {
					this.invoice.call_tag_box_count = 0;
					this.invoice.box_count = 0;
				}
				this.invoice.call_tag_dn = response.data.call_tag.call_tag_dn;
				this.invoice.ship_to_code = response.data.call_tag.ship_to_code;
				response = await apiSelectPartner({
					code: this.invoice.ship_to_code,
				});

				if (response.data.partner) {
					this.setShipTo(response.data.partner);
				}

				// const { data } = await apiSelectInvoice({
				// 	invoice_no: this.$route.query.invoice_no,
				// });
				// this.setInvoice(data.invoice);
			}
			inputSelectOnClick();
		},
		// async test() {
		// 	const { data } = await apiInsertInvoice(this.invoice);

		// 	if (data.result) {
		// 		this.$toast.success('Saved successfully');
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },

		async salesOrder() {
			// await this.$alertify.confirm(
			// 	'Do you want to Label print?',
			// 	() => this.salesOrderPrint('Y'),
			// 	() => this.salesOrderPrint('N'),
			// );

			await this.salesOrderPrint('N');
		},
		canVoid() {
			//console.log(this.user);
			//console.log(this.user.user_type);
			if (this.user.admin) return true;
			else if (this.invoice.status_code == 'O' && this.user.user_type == 'salesman') return true;
			else if (this.invoice.status_code != 'O' && this.user.user_type == 'salesman' && !this.user.so_void) return false;
			else return this.user.so_void;
		},

		// packingPrintHistoryModalAction() {
		// 	this.$refs.packingPrintHistoryModal.action();
		// },
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_wh_return');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Warehouse Return -> Add');

			if (this.$route.params.temp_invoice_no > 0) {
				//console.log('temp invoice');
				this.invoice.temp_invoice_no = this.$route.params.temp_invoice_no;
			} else {
				this.invoice.so_date = today();
				if (this.$route.query.initial_invoice_type) this.invoice.invoice_type = this.$route.query.initial_invoice_type;
			}
		} else {
			this.$store.commit('setSubTitle', 'Warehouse Return -> Detail');
			this.invoice.invoice_no = this.$route.query.invoice_no;

			if (!this.invoice.invoice_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();

		if (this.mode == 'add' && !this.$route.query.ship_to_code && !(this.invoice.temp_invoice_no > 0)) {
			//console.log(this.invoice.ship_to_code);
			this.$nextTick(function() {
				//console.log(this.$refs.shipto.$el.children[0]);
				//console.log(this.$refs.remark1);
				this.$refs.shipto.$el.children[0].focus();
			});
		}
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}

.remark-table {
	border: 1px solid lightgray;
	padding-right: 2px;
}

.view_tbl3 {
	width: 100%;
}
.view_tbl3 tbody th {
	font-size: 12px;
	color: #222;
	text-align: right;
}
.view_tbl3 tbody .top_th {
	padding: 4px 0px;
	vertical-align: top;
	line-height: 24px;
}
.view_tbl3 tbody td {
	padding: 1px 2px;
}

.remark_int {
	border: 0;
	height: 22px;
	width: 100%;
	font-size: 12px;
	padding: 0 4px 0 4px;
}
</style>
